import Text11 from '@sdk/components/ui/typography/Text11';
import styled, { useTheme } from 'styled-components';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import { SvgComponentType } from '@sdk/types';
import Row from '@sdk/components/ui/spacing/Row';
import Text16 from '@sdk/components/ui/typography/Text16';
import gettext from '@sdk/lang/gettext';
import Column from '@sdk/components/ui/spacing/Column';
import { SpacingProps } from '@sdk/components/ui/spacing/Spacing';

const OrderIndicator = styled(Column)<{ color: string }>`
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  background-color: ${(props): string => props.color};
  border-radius: 50%;
  margin-right: 10px;
`;

type CenteredRowProps = { isActive?: boolean };
const CenteredRow = styled(Row)<CenteredRowProps & SpacingProps>`
  align-items: center;
  opacity: ${(props): number => (props.isActive ? 1 : 0.65)};
`;

type StepConfig = {
  label: string;
  icon: SvgComponentType;
};

type Props = {
  step: StepConfig;
  isActive: boolean;
  number: number;
  hideStepNumber?: boolean;
};

export const NumberedStepIndicator = ({ step, isActive, number, hideStepNumber }: Props) => {
  const theme = useTheme();
  const color = isActive ? theme.colors.primary : theme.colors.gray;

  return (
    <Column bottom={60}>
      {!isActive && <step.icon />}
      {isActive && <StyledSvg color={color} svg={step.icon} />}
      <CenteredRow top={25} isActive={isActive}>
        {!hideStepNumber && (
          <OrderIndicator color={color}>
            <Text16 color={theme.colors.white} bold>
              {number}
            </Text16>
          </OrderIndicator>
        )}
        <Text11 color={color} uppercase bold>
          {gettext(step.label)}
        </Text11>
      </CenteredRow>
    </Column>
  );
};
